import React from 'react'

const SEGMENTS = [
  { value: 'firm', label: 'Firm', activeBackground: '#2f7a3e', showDot: true },
  { value: 'allowance', label: 'Allowance', activeBackground: '#c66a45', showDot: false },
  { value: 'tbd', label: 'TBD', activeBackground: '#8c5b00', showDot: false }
]

const styles = {
  container: {
    display: 'inline-flex',
    background: '#ece5d3',
    borderRadius: 999,
    padding: 3,
    border: '1px solid #e0d8c2'
  },
  segment: {
    padding: '5px 12px',
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background 0.12s',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    border: 'none',
    outline: 'none',
    lineHeight: 1.2
  },
  dot: {
    width: 5,
    height: 5,
    borderRadius: '50%',
    background: 'currentColor',
    flexShrink: 0
  }
}

const StatusSegmented = ({ value, onChange }) => {
  return (
    <div style={styles.container}>
      {SEGMENTS.map((seg) => {
        const active = value === seg.value
        const segStyle = {
          ...styles.segment,
          background: active ? seg.activeBackground : 'transparent',
          color: active ? '#fff' : '#6f7a6b'
        }
        return (
          <button
            key={seg.value}
            type="button"
            style={segStyle}
            onClick={() => onChange && onChange(seg.value)}
          >
            {seg.showDot && <span style={styles.dot} />}
            {seg.label}
          </button>
        )
      })}
    </div>
  )
}

export default StatusSegmented
